import { useEffect } from "react";

/**
 * Hook to set document title (React 19 compatible)
 * Replaces react-helmet for title management
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
